module.exports = __webpack_public_path__ + "img/gai2.560d762b.jpg";